import Tooltip from "@/tooltip";
import { ChevronDownIcon, PlusCircleIcon, StarIcon } from "@heroicons/react/20/solid";
import { useMemo, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Actions as AUTHENTICATION_ACTIONS } from "../../../store/actions/authenticationActions";
import { Actions as COMPANY_ACTIONS } from "../../../store/actions/companyActions";
import styles from "./CompanyModalStyles.module.css";

const mapToOption = (option) => {
	if (option.element) return option.element;
	return <ActionListOption {...option} />;
};

function ActionListOption({ label, icon: Icon, onClick, divider, title, onIconClick }) {
	return (
		<div
			className={title ? styles["company-list-title"] : styles["company-list-option"]}
			onClick={() => onClick && onClick()}
			tabIndex={0}
		>
			<div className={styles["company-list-option-label"]}>
				<h1>{label}</h1>
				{Icon && (
					<Icon
						className={styles["company-list-option-icon"]}
						style={{
							cursor: onIconClick ? "pointer" : "default",
						}}
						onClick={onIconClick}
					/>
				)}
			</div>

			{divider && <div className={styles["company-list-divider"]} />}
		</div>
	);
}

function CompanyModal({
	organisations,
	children,
	as,
	className,
	switchCompany,
	createDemoCompany,
	setNewCompanyModal,
	...props
}) {
	const [open, setOpen] = useState(false);
	const [companySearch, setCompanySearch] = useState(false);
	const [companyFilter, setCompanyFilter] = useState("");
	const navigate = useNavigate();
	const TagName = as ? as : "div";
	const disabled = props.disabled ? props.disabled : false;

	const demoCompany = useMemo(() => {
		const demo = organisations?.find((org) => [true, "yes", "true"].includes(org.isDemo));

		return {
			value: demo?.id,
			name: `${demo?.name || "Demo Company"}`,
			isDemo: true,
		};
	}, [JSON.stringify(organisations)]);

	const optionList = useMemo(() => {
		const nonDemo = organisations?.filter((o) => !o.isDemo);
		const filtered = nonDemo?.filter((o) => o.name?.toLowerCase().includes(companyFilter?.toLowerCase()));

		const addNewCompany = [
			{
				label: "Add New Company",
				icon: PlusCircleIcon,
				onClick: () => {
					setNewCompanyModal(true);
					setOpen(false);
				},
			},
			{
				title: true,
				divider: true,
			},
			nonDemo?.length > 0 && {
				label: "Switch Company",
				title: true,
				// icon: !companySearch ? MagnifyingGlassIcon : undefined,
				// onIconClick: () => setCompanySearch(!companySearch),
			},
			nonDemo?.length > 0 && {
				title: true,
				divider: true,
			},
			// companySearch && {
			// 	element: (
			// 		<div
			// 			className={styles["company-list-search-box"]}
			// 			tabIndex={0}
			// 		>
			// 			<MagnifyingGlassIcon
			// 				className={"text-gray"}
			// 				tabIndex={0}
			// 			/>
			// 			<input
			// 				tabIndex={0}
			// 				onBlur={() => {
			// 					setCompanySearch(false);
			// 					setCompanyFilter("");
			// 				}}
			// 				placeholder="Search"
			// 				value={companyFilter}
			// 				onChange={(e) => setCompanyFilter(e.target.value)}
			// 			/>
			// 		</div>
			// 	),
			// },
			// companySearch &&
			// 	nonDemo?.length > 0 && {
			// 		title: true,
			// 		divider: true,
			// 	},
		]
			.filter((option) => option)
			.map(mapToOption);

		const companyList = [
			...filtered?.map((option) => ({
				label: option?.name,
				onClick: () => {
					switchCompany(option.id);
					setOpen(false);
				},
			})),
		]
			.filter((option) => option)
			.map(mapToOption);

		const demo = [
			nonDemo?.length > 0 && {
				title: true,
				divider: true,
			},
			{
				label: "Demo Company",
				icon: StarIcon,
				onClick: () => {
					if (!demoCompany?.value) {
						navigate("/demo");
					} else {
						switchCompany(demoCompany.value);
					}
					setOpen(false);
				},
			},
		]
			.filter((option) => option)
			.map(mapToOption);

		return [...addNewCompany, <div style={{ maxHeight: "50vh", overflow: "auto" }}>{companyList}</div>, ...demo];
	}, [JSON.stringify(organisations), companyFilter, companySearch]);

	return (
		<TagName
			{...{
				className: className ? className : styles["company-list"],
				...props,
			}}
			tabIndex={0}
			onFocus={() => !disabled && setOpen(true)}
			onBlur={() => {
				if (disabled || companySearch) return;
				setOpen(false);
				setCompanySearch(false);
				setCompanyFilter("");
			}}
		>
			<Tooltip
				isOpen={open}
				direction="down"
				position="left"
				arrow={false}
				tabIndex={0}
				distance={10}
				contentClassName={styles["company-list-options"]}
				content={<>{optionList ? optionList : <div>No Options</div>}</>}
			>
				{children}
				<ChevronDownIcon
					className={`text-dark-gray ${open ? "rotate-180" : ""}`}
					tabIndex={0}
					style={{
						padding: 0,
						height: "2rem",
						verticalAlign: "text-top",
						transform: open ? "rotate(180deg)" : "rotate(0deg)",
						transition: "transform 0.2s ease-in-out",
					}}
				/>
			</Tooltip>
		</TagName>
	);
}

const mapStateToProps = (state) => {
	const currentOrg = state.company?.settings?.org;
	return {
		organisations: state.organisations?.filter((org) => org.id != currentOrg) || [],
		// open: state.company.isCompanyModalOpen,
		isAdvisor: state?.my?.profile?.isAdvisor,
	};
};

const mapDispatchToProps = (dispatch) => ({
	// setOpen: (open) => dispatch(COMPANY_ACTIONS.setCompanyModal(open)),
	createDemoCompany: (country) => dispatch(AUTHENTICATION_ACTIONS.createDemoCompany(country)),
	switchCompany: (companyId) => dispatch(AUTHENTICATION_ACTIONS.switchCompany(companyId)),
	setNewCompanyModal: () => dispatch(COMPANY_ACTIONS.setNewCompanyModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyModal);
